import { render, staticRenderFns } from "./AuditQuota.vue?vue&type=template&id=00456936&"
import script from "./AuditQuota.vue?vue&type=script&lang=js&"
export * from "./AuditQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports